import { render, staticRenderFns } from "./EnlaceMenuSimpleResaltado.vue?vue&type=template&id=5cdb0bc0&scoped=true&"
import script from "./EnlaceMenuSimpleResaltado.vue?vue&type=script&lang=js&"
export * from "./EnlaceMenuSimpleResaltado.vue?vue&type=script&lang=js&"
import style0 from "./EnlaceMenuSimpleResaltado.vue?vue&type=style&index=0&id=5cdb0bc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cdb0bc0",
  null
  
)

export default component.exports